import { render } from "./Maremex.vue?vue&type=template&id=3fc91db3"
import script from "./Maremex.vue?vue&type=script&lang=js"
export * from "./Maremex.vue?vue&type=script&lang=js"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__